import {
  GetCurrency,
  GetCurrencySuccess,
  GetCurrencyError,
  GET_CURRENCY,
  GET_CURRENCY_SUCCESS,
  GET_CURRENCY_ERROR,
  CurrencyInfo,
} from './types'

export const getCurrencyFetch = (): GetCurrency => {
  return {
    type: GET_CURRENCY,
    payload: [],
  }
}

export const getCurrencySuccess = (value: CurrencyInfo[]): GetCurrencySuccess => {
  return {
    type: GET_CURRENCY_SUCCESS,
    payload: value,
  }
}

export const getCurrencyError = (value: boolean): GetCurrencyError => {
  return {
    type: GET_CURRENCY_ERROR,
    payload: value,
  }
}
